import { ApiRequest, ApiRequestBlob, ApiRequestNoLoder } from "../../services/api"

export const GetUserDetails = async (userId) => {
    return await ApiRequest("GET", "admin-user-details?userId="+userId)
}
export const GetProfileDetails = async (userId) => {
    return await ApiRequest("GET", "admin-profile-details?userId="+userId)
}
export const GetReportsDownload = async (query) => {
    return await ApiRequestBlob("GET", "admin/get-emp-data?"+query)
}
export const GetReportsData = async (query) => {
    return await ApiRequest("GET", "admin/get-emp-data?"+query)
}

export const GetDownloadPDF = async (query) => {
    return await ApiRequest("GET", "admin/pdf?"+query)
}